import React, { useEffect, useState } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Collapsible, IconButton } from '@openedx/paragon';
import { Minus, Plus } from '@openedx/paragon/icons';

import { useModel } from '../../../generic/model-store';
import genericMessages from '../../../generic/messages';
import { useContextId } from '../../../data/hooks';
import messages from '../messages';
import SectionTitle from './SectionTitle';
import SequenceLink from './SequenceLink';
import { getSequenceMetadata } from '../../../courseware/data/api';
import { getOutlineTabData, getCourseBlocks } from '../../data/api';

interface Props {
  defaultOpen: boolean;
  expand: boolean;
  section: {
    complete: boolean;
    sequenceIds: string[];
    title: string;
    hideFromTOC: boolean;
  };
  courseSequence: any; // Replace `any` with proper type if possible
  sectionId: string;
}

const Section: React.FC<Props> = ({
  defaultOpen,
  expand,
  section,
  courseSequence,
  sectionId
}) => {
  const intl = useIntl();
  const courseId = useContextId();
  const {
    complete,
    sequenceIds,
    title,
    hideFromTOC,
  } = section;
  // const {
  //   courseBlocks: {
  //     sequences,
  //   },
  // } = useModel('outline', courseId);

  const sequences = courseSequence;

  

  const [newUniteds, setUniteds] = useState();
  const [unitIDs, setUnitIds] = useState();
  const [outlineData, setOutlineData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  


  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(expand);
  }, [expand]);




  useEffect(() => {
    const fetchDataForIds = async (ids) => {
      if (!ids || typeof ids !== 'object') {
        console.error("Invalid object:", ids);
        return null;
      }

      try {
        const accumulatedUniteds = {};
        const accumulatedUnitIds = [];

        for (const id of Object.keys(ids)) {
          if (ids[id].sectionId === sectionId) {
            const sectionUnits = await getSequenceMetadata(id);
            accumulatedUniteds[id] = sectionUnits;
            accumulatedUnitIds.push(id);
          }
        }

        setUniteds(accumulatedUniteds);
        setUnitIds(accumulatedUnitIds);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
      }
    };

    fetchDataForIds(sequences);
  }, [sequences, sectionId]);

 


 
  useEffect(() => {
    // Save the state to localStorage whenever it changes
    localStorage.setItem(`section_${courseId}_${title}`, JSON.stringify(open));
  }, [courseId, title, open]);


  useEffect(() => {
    setTimeout(() => {
      const collapsibles = document.querySelectorAll('.pgn_collapsible');
     
      collapsibles.forEach((collapsible, index) => {
        // Check if any element with the class "clicked-title" exists within the collapsible content
        const content = collapsible.querySelector('.pgn-transition-replace-group');
        const clickedTitleElement = content.querySelector('.clicked-title');
        
        // Output the result
        if (!clickedTitleElement) {
          
          collapsible.querySelector('.collapsible-icon button').click(); // Close only the collapsibles without the class
          // Do something with the found element if needed
        } else {
          
        }
      });
  
      // Your existing code...
    }, 5000); // Adjust the delay as needed
  }, []);

  return (
    <li>
      <Collapsible
        className="mb-2"
        styling="card-lg"
        title={<SectionTitle {...{ complete, hideFromTOC, title }} />}
        open={open}
        // onToggle={() => { setOpen(!open); }}
        iconWhenClosed={(
          <IconButton
            alt={intl.formatMessage(messages.openSection)}
            iconAs={Plus}
            onClick={() => { setOpen(true); }}
            size="sm"
          />
        )}
        iconWhenOpen={(
          <IconButton
            alt={intl.formatMessage(genericMessages.close)}
            iconAs={Minus}
            onClick={() => { setOpen(false); }}
            size="sm"
          />
        )}
      >
        {/* <ol className="list-unstyled">
          {sequenceIds.map((sequenceId, index) => (
            <SequenceLink
              key={sequenceId}
              id={sequenceId}
              sequence={sequences[sequenceId]}
              first={index === 0}
            />
          ))}
        </ol> */}
      {newUniteds ? (
          Object.keys(newUniteds).map(sequenceId => (
            <ol key={sequenceId} className="list-unstyled">
              {newUniteds[sequenceId].units.map((unit, index) => (
                <SequenceLink
                  key={unit.id}
                  id={unit.id}
                  courseId={courseId}
                  sequence={unit || {}}
                  unit={unit || {}}
                  first={index === 0}
                />
              ))}
            </ol>
          ))
        ) : (
          <p>Loading sections...</p>
        )}


      </Collapsible>
    </li>
  );
};

export default Section;
